import { CONSTANT_VALUES } from './../constants/constant-values';
import * as CryptoJS from 'crypto-js';

export class Encryption {
  private algo: any;
  private salt;

  constructor() {
    this.algo = CryptoJS.algo;
    this.salt = CONSTANT_VALUES.SALT_FOR_HASHING;
  }

  /**
   *
   * @param {any} password
   * @returns {PromiseLike<any>}
   *
   * @memberOf Encryption
   */
  hash(password): PromiseLike<any> {
    return new Promise((accept, reject) => {
      const encrypted = CryptoJS.PBKDF2(password, this.salt, { keySize: 256 / 32, iterations: 5000, hasher: this.algo.SHA256 }).toString();
      return accept(encrypted);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/encryption.ts